import React, { Component } from 'react';
import { Query } from 'react-apollo';
import {
  Form, FormGroup, Label, Input,
} from 'reactstrap';
import { GET_BOXES } from '../../../query/query';

function intersectBoxId(id, shortId) {
  if (id.substring(0, 5) === shortId) {
    return true;
  }
  return false;
}

function NoBox() {
  return <p>Il n'y a pas de box associée à cet email</p>;
}

class ManyBoxes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: '',
    };

    this.handleSelectedBoxChange = this.handleSelectedBoxChange.bind(this);
  }

  handleSelectedBoxChange(e) {
    this.props.onSelectedBoxChange(e.target.value);
    this.setState({
      selectedValue: e.target.value,
    });
  }

  render() {
    let nameShown;
    const options = this.props.data.map(({ name, _id, nickname }) => {
      if (nickname) {
        nameShown = `${name} (${nickname})`;
      } else {
        nameShown = name;
      }
      return <option key={_id} value={_id}>{nameShown}</option>;
    });
    options.unshift(<option key="0" value="" />);
    return (
      <Input type="select" value={this.state.selectedValue} onChange={this.handleSelectedBoxChange}>
        {options}
      </Input>
    );
  }

  componentWillMount() {
    if (this.props.urlBoxId) {
      this.props.data.forEach(({ _id }) => {
        if (intersectBoxId(_id, this.props.urlBoxId)) {
          this.props.onSelectedBoxChange(_id);
          this.setState({
            selectedValue: _id,
          });
        }
      });
    } else {
      const box = this.props.data[0];
      this.props.onSelectedBoxChange(box._id);
      this.setState({
        selectedValue: box._id,
      });
    }
  }
}

const SAVGetBoxes = (props) => (
  // variables={props} : an object containing the variables we want to pass to the query
  <Query query={GET_BOXES} variables={props}>
    {({ loading, error, data: { savGetBoxes = [] } } = {}) => {
      if (loading) {
        return <p>Loading...</p>;
      }
      if (error) {
        return <p>Error</p>;
      }

      const boxNumber = savGetBoxes.length;
      if (boxNumber === 0) {
        return <NoBox />;
      }
      return (
        <ManyBoxes
          onSelectedBoxChange={props.onSelectedBoxChange}
          urlBoxId={props.urlBoxId}
          data={savGetBoxes}
        />
      );
    }}
  </Query>
);

class LoveboxList extends Component {
  constructor(props) {
    super(props);

    this.handleSelectedBoxChange = this.handleSelectedBoxChange.bind(this);
  }

  handleSelectedBoxChange(e) {
    this.props.onSelectedBoxChange(e);
  }

  render() {
    return (
      <Form>
        <FormGroup>
          <Label>
            Choisir Lovebox
          </Label>
          <SAVGetBoxes
            email={this.props.email}
            onSelectedBoxChange={this.handleSelectedBoxChange}
            urlBoxId={this.props.urlBoxId}
          />
        </FormGroup>
      </Form>
    );
  }
}

export { LoveboxList };



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/form/lovebox-list.js